import type * as T from 'three';
import type { SceneKit } from '@london-life/game/scene/kit';

// What every set piece is drawn from: its size (w across, d deep, h high, in metres), its main colour, and
// the optional kind and words. A piece stands on the floor at the origin facing +z (towards the camera's side
// of the room); the scene turns and moves it.
export type Piece = { w: number; d: number; h: number; c: string; variant?: string; label?: string };
export type Draw = (k: SceneKit, p: Piece, g: T.Group) => void;

// four legs under a top of w × d at height h
export function legs(k: SceneKit, w: number, d: number, h: number, colour: string, g: T.Group, thick = 0.05) {
  for (const [x, z] of [
    [-1, -1],
    [1, -1],
    [-1, 1],
    [1, 1],
  ] as const)
    k.box(thick, h, thick, colour, (x * (w - thick * 2)) / 2, h / 2, (z * (d - thick * 2)) / 2, g);
}

// a few things in a row along x (bottles on a shelf, books), in turning colours
export function row(
  k: SceneKit,
  count: number,
  width: number,
  y: number,
  z: number,
  g: T.Group,
  colours: string[],
  size = { w: 0.06, h: 0.22, d: 0.06 },
) {
  for (let i = 0; i < count; i += 1) {
    const x = -width / 2 + (width * (i + 0.5)) / count;
    k.box(size.w, size.h, size.d, colours[i % colours.length]!, x, y + size.h / 2, z, g);
  }
}

export const BOTTLES = ['#2f6b3f', '#7a3b1d', '#c9a227', '#3a5f8a', '#8a2b4a', '#e8e1d0'];
export const BOOKS = ['#8a2b2b', '#2b4a8a', '#c9a227', '#2f6b3f', '#5b3a8a', '#d9822b', '#3d4650'];
export const FRUIT = ['#e63946', '#f4a261', '#2a9d8f', '#e9c46a', '#8ac926', '#ff7b00'];
